const axios = require("axios").default
const Vue = require('vue').default
const VueAwesomeSwiper = require('vue-awesome-swiper')
const moment = require("moment")

Vue.use(VueAwesomeSwiper)

var PageTop = {
  data: function () {
    return {
      isShowModal: false,
      modalArticle: null,
      isShow: [],
      isDetail: false,
      info: 0,
      returnTop: true,
      date: '',
      time: '',
      tmpHeatMapOption: ["1"],
      trafficInfo: [],
      tsukodomeData: []
    }
  },
  watch: {
  },
  created() {
    var _self = this
    axios.get('https://nexco.tag-labs.jp/w-nexco/map/timedata_kansai_navi_2021.json?t=' + (new Date()).getTime())
    .then((res)=> {
      this.trafficInfo = res.data
    })

    // エンジ関西 通行止めデータ
    axios.get('https://nexco.tag-labs.jp/w-nexco/map/e_kansai_display.json?t=' + (new Date()).getTime())
    .then((res)=> {
      // 仮設情報板のデータ
      var data = res.data
      var tsukodome = "099"
      data = data.filter(function(d) {
        return d.number == tsukodome
      })
      data.forEach(function(d) {
        switch(d.id) {
          case "1010":
            _self.tsukodomeData.push("RID_2_1_001")
            break
          case "1020":
            _self.tsukodomeData.push("RID_2_1_002")
            break
          case "1030":
            _self.tsukodomeData.push("RID_2_1_003")
            break
          case "1040":
            _self.tsukodomeData.push("RID_2_1_018")
            break
          case "1110":
            _self.tsukodomeData.push("RID_2_1_009")
            break
          case "1120":
            _self.tsukodomeData.push("RID_2_1_010")
            break
          case "1130":
            _self.tsukodomeData.push("RID_2_1_011")
            break
          case "1140":
            _self.tsukodomeData.push("RID_2_1_017")
            break
        }
      })
    })
    .catch(function(e) {
      console.log(e)
    })
    // WP通行止め情報
    axios.get('/2021_chugoku/cms/route.json?t=' + (new Date()).getTime())
    .then((res)=> {
      res.data.forEach((roadData)=> {
        if (roadData.custom.mark_type == 'stop') {
          // ルートIDがあれば使う
          if (roadData.custom.route_json) {
            var route = JSON.parse(roadData.custom.route_json)
            if (route['id']) {
              _self.tsukodomeData.push(route['id'])
            }
          }
        }
      })
    })
    .catch(function(e) {
      console.log(e)
    })

    const result = this.informations.find((v) => {
      if (v.custom.checkbox && v.custom.checkbox.indexOf('modalOn') > -1) {
        var start = moment(v.custom.modal_date_start, "YYYY-MM-DD HH:mm:ss")
        var end = moment(v.custom.modal_date_end, "YYYY-MM-DD HH:mm:ss")
        var now = moment()
        if (start.isSameOrBefore(now) && now.isSameOrBefore(end)) {
          return true
        }
      }
    })
    if(result) {
      this.isShowModal = true
      this.modalArticle = result
    }
  },
  mounted: function () {
    var timer = setInterval(this.trafficTime, 1000);


    // google map
    var domain = location.href.replace("https://", "").replace("http://", "").replace(/./g, "").replace(/\//g, "")
    domain = domain.replace(/\?.*$/, '')
    domain = domain.replace(/#.*$/, '')
    var year = (new Date()).getFullYear()
    var channel = domain + year
    var sc = document.createElement('script')
    sc.setAttribute('src', '//maps.google.com/maps/api/js?v=3.45&key=AIzaSyAoTjJCRVnZ0nIfAnHCZDxmFfGawQHQIf8&channel=' + channel + '&language=ja&libraries=geometry')
    document.head.appendChild(sc)
    this.initGoogleMap()

    var tsc = document.createElement('script')
    tsc.setAttribute('src', 'https://platform.twitter.com/widgets.js')
    document.head.appendChild(tsc)

    // Route Monitoring
    this.setRouteTime();
  },

  methods: {
    initGoogleMap() {
      if (window.google) {
        initGoogleMap()
      } else {
        setTimeout(()=> {
          this.initGoogleMap()
        }, 500)
      }
    },
    trafficTime: function() {
      var current_date = new Date()
      this.time = ('0' + current_date.getHours()).slice(-2) + ':' + ('0' + current_date.getMinutes()).slice(-2)
      this.date = current_date.getFullYear() + '/' + (current_date.getMonth() + 1)+ '/' + current_date.getDate()
    },
    getTrafficInfo(rid) {
      if (this.tsukodomeData.indexOf(rid) > -1) {
        return {
          text: '一部通行止',
          cls: 'stopped'
        }
      }

      var roadData = this.trafficInfo.find((d) => {
        return d.id == rid
      })
      if (roadData) {
        var time = roadData.time
        var base = roadData.base_time
        if (time && base) {
          var x = time / base
          if (x > 2) {
            return {
              text: '渋滞',
              cls: 'traffic-jam'
            }
          } else if (x > 1.5) {
            return {
              text: '混雑',
              cls: 'congestion-color'
            }
          } else {
            return {
              text: '順調',
              cls: 'going-well'
            }
          }
        }
      }
      return {
        text: '-',
        cls: ''
      }
    },
    setRouteTime() {
      ROUTETIME.setTimeCOMAPROBE(
        function () {
          //所要時間更新後の処理(通常時間と比較して色付けなど)
          elementList = document.querySelectorAll(".control_time_comaprobe");
          for (i = 0; i < elementList.length; i++) {
            if(elementList[i].innerText == -1){
              elementList[i].innerText = "!";
            } else {
              elementList[i].innerHTML = elementList[i].textContent + "<small>分</small>";
            }
          }
        },
        5*60*1000 //更新間隔(ミリ秒) //更新間隔(ミリ秒)
      );
    }
    // getRoadStyle(rid) {
    //   if (this.tsukodomeData.indexOf(rid) > -1) {
    //     return 'color: #f33'
    //   } else {
    //     return 'color: #aaa'
    //   }
    // },
    // getRoadHtml(rid) {
    //   if (this.tsukodomeData.indexOf(rid) > -1) {
    //     return '通行止め'
    //   } else {
    //     return '準備中'
    //   }
    // }
  }
}

module.exports = PageTop